import { Link } from "react-router-dom";
import useReactGASend from "../../hooks/useReactGASend";
import useSelectBrand from "#hooks/styles/useSelectBrand";

const MenuGroup = ({ category, items, onClick }) => {
  const isExternalLink = (url) => /^https?:\/\//i.test(url);
  const { color } = useSelectBrand();
  const { makeEventTrackFn } = useReactGASend();

  const trackLinkClick = (label) => {
    makeEventTrackFn({
      category: "event",
      action: label,
      body: { data_btn_nm: label },
    });
  };

  const renderLink = (label, value) => {
    return isExternalLink(value) ? (
      <a
        href={value}
        rel="noopener noreferrer"
        className={`py-2.5 px-5 border-2 border-${color} block w-full h-full rounded-[40px] text-gray-c-700 font-semibold`}
        onClick={() => {
          onClick();
          trackLinkClick(label);
        }}
      >
        {label}
      </a>
    ) : (
      <Link
        to={value}
        className={`py-2.5 px-5 border-2 border-${color} block w-full h-full rounded-[40px] text-gray-c-700 font-semibold`}
        onClick={() => {
          onClick();
          trackLinkClick(label);
        }}
      >
        {label}
      </Link>
    );
  };

  return (
    <div className="mb-10">
      <h3 className="mb-3.5 text-lg font-semibold text-neutral-950">
        {category}
      </h3>
      <ul className="flex flex-wrap gap-x-1 gap-y-2.5">
        {items.map(({ label, value }) => (
          <li key={value}>{renderLink(label, value)}</li>
        ))}
      </ul>
    </div>
  );
};

export default MenuGroup;
